import logoImage from '../assets/MooWoo_Logo.png';

export default function Logo({ className = '', onClick }) {
  return (
    <img 
      src={logoImage} 
      alt="MooWoo Logo" 
      className={`object-contain ${className}`}
      onClick={onClick}
    />
  );
}
